module.exports = __webpack_public_path__ + "img/sport-triathlon.ee2b62ba.jpg";